import React from "react";

function Structures(props) {
  return (
    <div>
      <h1>Prêts aux structures</h1>
      <div>
        <p>
          Nous proposons des forfaits spéciaux dédiés à vos structures. Tous les
          mois, nous vous préparons 5 jeux de société diversifiés.
        </p>
      </div>
      <p>
        L’adhésion à l’association LudoBlue est obligatoire, notamment pour
        la couverture assurantielle, elle est de 30 euros pour les assistantes
        maternelles, 50 euros par an pour une structure à gestion associative,
        70 euros pour les autres structures.
      </p>
      <ul>
        <li>
          A raison de 5 jeux de société maximum / 4 semaines :
          l&#8217;abonnement de 1 an est de 130 €
        </li>
        <li>A raison de 5 jeux géant maximum / 1 jour : 10 € / jeu</li>
      </ul>
    </div>
  );
}

export default Structures;
